import Image from 'next/image';

import Button from '@hiredigital/ui/Button/Button';
import Accordion from '@hiredigital/ui/Accordion/Accordion';
import InteractiveButton from '@components/InteractiveButton/InteractiveButton';

import Styles from './TextContent.module.scss';
import BaseRichText from './BaseRichText';

import _reduce from 'lodash/reduce';
import _kebabCase from 'lodash/kebabCase';

export const slugPrefixMap = {
  HiringGuide: '/hiring-guides/',
  JobDescription: '/job-descriptions/',
};

export const extractHeadings = (sections) => {
  const headings = [];
  sections.map((section) =>
    headings.push(
      ...(section?.title
        ? [{ type: 'heading-two', title: section?.title, target: _kebabCase(section?.title) }]
        : []),
      ...(section?.question
        ? [{ type: 'heading-two', title: section?.question, target: _kebabCase(section?.question) }]
        : []),
      ..._reduce(
        section?.text?.raw?.children,
        (acc, child) => {
          const type = child?.type;
          const className = child?.className;

          let children;
          if (type === 'heading-two' || type === 'heading-three') children = child?.children;
          if (type === 'class' && className === 'toc') children = child?.children?.[0]?.children;
          if (!children) return acc;

          const headingText = _reduce(children, (text, textNode) => text + textNode.text, '')
            .trim()
            .replace(/\n/g, '');
          acc.push({ type, title: headingText, target: _kebabCase(headingText) });
          return acc;
        },
        []
      )
    )
  );
  return headings;
};

const TextContent = ({
  section: item,
  index: ind,
  updatedAnalyticsData,
  headings: allHeadings,
}) => {
  switch (item.type) {
    case 'BaseImage':
      return (
        <Image
          key={ind}
          className={Styles.baseImage}
          src={item?.image?.url}
          alt={'baseImage'}
          width={item?.image?.width}
          height={item?.image?.height}
        />
      );
    case 'BaseRichText':
      return (
        <BaseRichText
          key={ind}
          allHeadings={allHeadings}
          showCopyButton={item?.showCopyButton}
          dangerouslySetInnerHTML={{
            __html: item?.text?.html,
          }}
        />
      );
    case 'CaseCallToAction':
      return (
        <div key={ind} className={Styles.caseCallToAction}>
          <h2 id={_kebabCase(item.title)} className={Styles.caseCtaTitle}>
            {item.title}
          </h2>
          <p className={Styles.caseCtaDescription}>{item.description}</p>
          <InteractiveButton
            className={Styles.jdCallToActionButton}
            type={Button.Type.BLUE}
            title={item.label || 'Get Started'}
            href={{
              pathname: item.url || `/get-started`,
              query: { ...updatedAnalyticsData },
            }}>
            {item.label || 'Get Started'}
          </InteractiveButton>
          {item.button2 && (
            <InteractiveButton
              className={Styles.jdCallToActionButton}
              type={Button.Type.BLUE_OUTLINE}
              title={item.button2.label || 'Read More'}
              href={{
                pathname: item.button2.url || `/`,
                query: { ...updatedAnalyticsData },
              }}>
              {item.button2.label || 'Read More'}
            </InteractiveButton>
          )}
        </div>
      );
    case 'FaqSection':
      return (
        <div key={ind} className={Styles.faqSection}>
          <h2 id={_kebabCase(item.title)} className={Styles.faqTitle}>
            {item.title}
          </h2>
          {item && (
            <Accordion
              className={Styles.faqAccordion}
              data={item.faqs.map(({ question: q, answer: a }) => ({
                title: q,
                content: a?.html,
              }))}
            />
          )}
        </div>
      );
    case 'FeaturedQuestion':
      return (
        <div key={ind} className={Styles.featuredQuestion}>
          <h2 id={_kebabCase(item.question)} className={Styles.featuredQuestionTitle}>
            {item.question}
          </h2>

          <div className={Styles.featuredQuestionText}>
            <div
              className={Styles.baseRichText}
              dangerouslySetInnerHTML={{ __html: item.answer.html }}
            />
          </div>
        </div>
      );
    default:
      console.log(item.type);
  }
};

export default TextContent;
